<template>
  <v-chart
    v-loading="loading"
    style="width: 100%;height: 100%"
    :options="lineOption"
    :autoresize="true"
    :init-options="{ devicePixelRatio: 1 }"
  ></v-chart>
</template>

<script>
import { CombustionLaboratoryApi } from '@wiz-api/huizhou2-business'
import dayjs from 'dayjs'

const combustionLaboratoryApi = new CombustionLaboratoryApi()

export default {
  name: 'barChart',

  data() {
    return {
      loading: false,
      lineOption: {
        color: ['#feff01'],
        legend: {
          data: ['任务数'],
          textStyle: {
            color: 'rgba(255,255,255,0.6)',
          },
          right: 5,
        },
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          top: 40,
          left: 10,
          right: 12,
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.6)',
            },
          },
          axisTick: {
            show: false,
          },
          data: []
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: 'rgba(255,255,255,0.6)',
            margin: 10,
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: 'rgba(255,255,255,0.1)',
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: '任务数',
            type: 'bar',
            barMaxWidth: 20,
            label: {
              position: 'top',
              show: true,
              color: '#41DAD4',
            },
            data: [],
          },
        ],
      }
    }
  },
  methods: {
    async initData(code) {
      this.loading = true
      // 查询近30天数据
      const [err, res] = await combustionLaboratoryApi.getDailyTaskCount({
        start: dayjs().subtract(30, 'day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      })
      this.loading = false
      if (!err && res) {
        // 取最近7条数据
        const data = res.sort((a, b) => {
          return dayjs(`${b.year}-${b.month}-${b.day}`).valueOf() - dayjs(`${a.year}-${a.month}-${a.day}`).valueOf()
        }).splice(0, 7).reverse()
        if (!err && res) {
          this.lineOption.series[0].data = data.map((item) => { return item.taskCount })
          this.lineOption.xAxis.data = data.map((item) => { return `${item.month}-${item.day}` })
        } else {
          this.lineOption.xAxis.data = []
          this.lineOption.series[0].data = []
        }
      }
    },
  },
  mounted() {
    this.initData()
  }
}
</script>
